import { YES_NO } from "../constants"
import {
  boundaryWallStatusOptions,
  currentSiteConditionOptions,
  landPlotUnitOptions,
  landUseZoneZoningOptions,
  mainEntranceDirectionOptions,
  plotShapeOptions,
  typeOfSaleOptions,
  utilitiesAvailableOptions,
} from "../sharedOptions"
import type { CategorySection } from "../types"

export const landSections: Record<string, CategorySection[]> = {
  Land: [
    {
      sectionTitle: "Land & Development Potential",
      fields: [
        { key: "plotSize", type: "number", label: "Plot Size", placeholder: "E.g., 5000", tooltip: "Enter the total area of the land plot in the local unit." },
        { key: "unitOfMeasurement", type: "dropdown", label: "Unit of Measurement", options: landPlotUnitOptions, placeholder: "Select unit", tooltip: "Select the unit for the Plot Size. E.g., Sq. Ft., Sq. Meters, Acres, Bigha, Guntha, etc." },
        { key: "plotSizeSqFt", type: "number", label: "Plot Size in Sq. Ft. [Auto-Calculated]", placeholder: "", tooltip: "System will calculate and display this. Provides a standardized area for comparison." },
        { key: "landUseZoneZoning", type: "dropdown", label: "Land Use Zone (Zoning)", options: landUseZoneZoningOptions, placeholder: "Select zoning", tooltip: "CRITICAL: Select the official zoning for the land as per the city's master plan. E.g., Commercial, Industrial, Agricultural, Institutional." },
        { key: "fsiFarPermitted", type: "number", label: "FSI / FAR Permitted", placeholder: "E.g., 2.5", tooltip: "Enter the permitted Floor Space Index or Floor Area Ratio. E.g., 2.5." },
        { key: "roadFrontage", type: "number", label: "Road Frontage (ft.)", placeholder: "Length in feet", tooltip: "Enter the length of the plot that is adjacent to the main road." },
      ],
    },
    {
      sectionTitle: "Site Conditions, Utilities & Vastu",
      fields: [
        { key: "currentSiteCondition", type: "dropdown", label: "Current Site Condition", options: currentSiteConditionOptions, placeholder: "Select", tooltip: "Select the current state of the plot. E.g., Vacant & Clear, Contains Old Structure for Demolition." },
        { key: "boundaryWallStatus", type: "dropdown", label: "Boundary Wall Status", options: boundaryWallStatusOptions, placeholder: "Select", tooltip: "Select the boundary type. E.g., Walled, Fenced, Partially Fenced, Open." },
        { key: "utilitiesAvailable", type: "multiselect", label: "Utilities Available", options: utilitiesAvailableOptions, placeholder: "Select all that apply", tooltip: "Select all utilities that are available at the plot boundary. E.g., Electricity Connection, Municipal Water Supply, Sewage/Drainage Line." },
        { key: "plotFacingDirection", type: "dropdown", label: "Plot Facing Direction", options: mainEntranceDirectionOptions, placeholder: "E.g., North, North-East", tooltip: "Select the direction the plot faces. E.g., North, East, North-East (Ishan), South-West (Nairutya)." },
        { key: "plotShape", type: "dropdown", label: "Plot Shape", options: plotShapeOptions, placeholder: "Select shape", tooltip: "Select the shape of the plot. E.g., Square (Vargakar), Rectangular (Aayutakar), Irregular." },
        { key: "isVastuReportAvailable", type: "yesno", label: "Is a Vastu Report Available?", options: YES_NO, tooltip: "Do you have a Vastu compliance report from a consultant?" },
      ],
    },
    {
      sectionTitle: "Financial Details",
      fields: [
        { key: "typeOfSale", type: "dropdown", label: "Type of Sale", options: typeOfSaleOptions, placeholder: "Select", tooltip: "Is this a Direct Sale or are you open to a Joint Venture (JV)?" },
        { key: "totalPriceOffered", type: "number", label: "Total Price Offered", placeholder: "E.g., 1,00,00,000", tooltip: "Enter the total expected sale price for the land." },
        { key: "pricePerSqFt", type: "number", label: "Price Per Sq. Ft. [Auto-Calculated]", placeholder: "", tooltip: "System will calculate this. Formula: (Total Price / Plot Size in Sq. Ft.)." },
      ],
    },
    {
      sectionTitle: "Legal & Documentation",
      fields: [
        { key: "titleDeedSaleDeed", type: "file", label: "Title Deed", tooltip: "Upload a scanned, clear copy of the property's Title Deed." },
        { key: "latestTaxReceipts", type: "file", label: "Latest Tax Receipts", placeholder: "" },
        { key: "plotDemarcationReportSurveyPlan", type: "text", label: "Plot Demarcation Report / Survey Plan", placeholder: "" },
      ],
    },
    {
      sectionTitle: "Media",
      fields: [
        { key: "propertyDescription", type: "richtext", label: "Property Description", tooltip: "Focus on logistical advantages." },
        { key: "propertyImages", type: "file", label: "Property Images", tooltip: "Upload photos." },
        { key: "floorPlan", type: "file", label: "Floor Plan / Site Layout", tooltip: "Upload site layout." },
      ],
    },
  ],
}
